<template>
    <div class="snapshot">
        <div class="panel-body">
            <div class="panel-row row">
                <h1 v-html="model.heading"></h1>
                <small class="pull-right" v-if="model.entityuser">Created by {{ model.entityuser.name }}</small>
            </div>
            <!-- Tag Panel -->
            <div v-if="$parent.show('tags')" class="tags panel-row row">
                <h3><i class="icon icon-tags pull-left"></i></h3>
                <fieldset>
                    <div id="form-tag">
                        <input-tag name="RightPane" :on-change="updateTags" :tags="model.tags" placeholder="+ Add Tags"></input-tag>
                    </div> <!-- .form-body -->
                </fieldset> <!-- .col-md-10 -->
            </div> <!-- .tags -->

            <div v-if="$parent.show('comments')" class="comments panel-row row">
                <div class="col-md-12">
                    <div class="media">
                        <ul v-if="model.comments" class="media commentList media-list">
                            <li v-for="(comment, key) in model.comments" :id="'commentListID-' + comment.public_id" class="media">
                                <div class="media-left">
                                    <span class="initial initial-sm" :class="'initial-style-' + comment.initials" v-html="comment.initials"></span>
                                </div>
                                <div class="media-body">
                                    <div class="commenter">
                                                <span class="sub-text">
                                                    <strong>{{ comment.first_name }} {{ comment.last_name }}</strong>
                                                    <span class="date">on {{ comment.created_at }}</span>
                                                </span>
                                        <button @click.prevent="deleteComment(comment.public_id, key)" type="button" class="btn btn-danger btn-sm commentDeleteBtns pull-right" >
                                            <i class="icon icon-cancel-small" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                    <div class="comment-outer">
                                        <div class="comment-inner">
                                            <p style="word-wrap: break-word;" v-html="comment.comment"></p>
                                        </div>
                                        <a @click.prevent="readmore('#commentListID-' + comment.public_id)" class="pull-right">...</a>
                                    </div>
                                </div>
                            </li>
                        </ul>
                        <div class="row comment-row">
                            <span class="initial initial-sm" :class="'initial-style-' + user.initials" v-if="user">{{ user.initials }}</span>
                            <textarea id="comment" v-model="model.comment" class="form-control col-sm-7 autoExpand" @keyup="commentExpand($event)" placeholder="Leave a note"></textarea>
                            <button @click="submitComment" class="btn btn-primary pull-right" id="commentBtn" :disabled="disableComment">
                                <i class="icon icon-edit"></i> Comment</button>
                        </div>
                    </div> <!-- .media -->
                </div> <!-- .col-md-10 -->
            </div> <!-- .comments -->
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            data: { default : '' }
        },
        data() {
            return {
                model:  this.data,
                disableComment: false,
                comment: '',
                user: window.currentUser
            }
        },
        created() {
            this.$eventHub.$on('updateOwner', this.updateOwner);
            this.model.comments = Object.keys(this.data.comments).map(key => this.data.comments[key]);
        },
        methods: {
            updateOwner(model) {
                if (model.public_id === this.model.public_id && model.entity === this.model.entity) {
                    this.$set(this.model, 'entityuser', model.entityuser);
                }
            },
            updateTags(data) {
                this.axios.post('/api/update-tags', {
                    id: this.model.public_id,
                    entity: this.model.entity,
                    tags: data
                }).then(() => {
                    this.$eventHub.$emit(this.model.entity + 'TableRefresh');
                });
            },
            submitComment() {
                this.disableComment = true;
                this.axios.post('/api/comment', {
                    id: this.model.public_id,
                    entity: this.model.entity,
                    comment: this.model.comment
                }).then((response) => {
                    this.disableComment = false;
                    this.model.comments.push({
                        public_id: response.data.id,
                        first_name: this.user.first_name,
                        last_name: this.user.last_name,
                        initials: this.user.initials,
                        created_at: 'now',
                        comment: this.model.comment
                    });
                    this.model.comment = '';
                });
            },
            deleteComment(id, index){
                Swal.fire({
                    title: '<i class="icon icon-question"></i> Are you sure?',
                    icon: 'warning',
                    confirmButtonText: '<i class="icon icon-cross"></i> Delete Comment',
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Yes, delete it!"
                }).then((result) => {
                    if (result.isConfirmed) {
                        Vue.delete(this.model.comments, index);
                        this.$store('/api/comment/delete', {public_id: id});
                        Swal.fire({
                            title: "Deleted!",
                            text: "The comment has been deleted.",
                            icon: "success"
                        });
                    }
                });
            },
            commentExpand(event){
                let el = event.target;
                setTimeout(function () {
                    el.style.cssText = 'height:auto; padding:0';
                    // for box-sizing other than "content-box" use:
                    // el.style.cssText = '-moz-box-sizing:content-box';
                    el.style.cssText = 'height:' + el.scrollHeight + 'px';
                }, 0);
            },
            readmore(id){
                $(id + ' .comment-inner').toggleClass('expand');
            },
        },
        // It's good to clean up event listeners before a component is destroyed.
        beforeDestroy () {
//                this.$eventHub.$off('set' + this.name + 'User', this.setUser);
        },
        components: {
            'InputTag': require('../components/InputTag.vue').default,
        }
    }
</script>
